const KIND_ACTIVITY = 'Activity';
const KIND_RECORD = 'Record';
const KIND_RECORD_AVAILABILITY = 'RecordAvailability';
const KIND_INDEX = 'Index';
const KIND_COMMENT = 'Comment';
const KIND_TARGETS = 'Targets';
const KIND_ZIELE = 'Ziele';
const KIND_ACTIVITY_SUMS = "ActivitySums";
const KIND_ACTIVITY_TOTALS = "ActivityTotals";
const KIND_BADGE = "Badge";
const KIND_STREAK = "Streak";
const KIND_WEEKREPORT = "WeekReport";

export default {
    KIND_ACTIVITY,
    KIND_ACTIVITY_SUMS,
    KIND_ACTIVITY_TOTALS,
    KIND_RECORD,
    KIND_RECORD_AVAILABILITY,
    KIND_INDEX,
    KIND_COMMENT,
    KIND_TARGETS,
    KIND_ZIELE,
    KIND_BADGE,
    KIND_STREAK,
    KIND_WEEKREPORT,
}